export default __webpack_public_path__ + "static/media/alert_icon.21e59c61.svg";